import React from 'react';
import { Snackbar } from '@genie-ui/react';
import PropTypes from 'prop-types';

const VARIANT_SX = {
  error: {
    '&.MuiSnackbarContent-root': {
      minWidth: 'unset',
      maxWidth: '300px',
      background: '#FCE7E6',
      borderBottom: '2px solid #AA0000',
      '& .MuiSnackbarContent-message': {
        display: 'contents',
        color: 'black',
        '& .genie-snackbarMessage': {
          alignItems: 'center',
          '& .genie-snackbarMessage__icon': {
            marginBottom: 0,
            svg: {
              path: {
                fill: '#AA0000',
              },
            },
          },
        },
      },
    },
  },
  success: {
    '&.MuiSnackbarContent-root': {
      width: 'min-content',
      background: '#E6F6F1',
      borderBottom: '2px solid #007A50',
      '& .MuiSnackbarContent-message': {
        display: 'contents',
        color: 'black',
        '& .genie-snackbarMessage': {
          alignItems: 'center',
          whiteSpace: 'nowrap',
          '& .genie-snackbarMessage__icon': {
            marginBottom: 0,
            svg: {
              path: {
                fill: '#007A50',
              },
            },
          },
        },
      },
    },
  },
  warning: {
    '&.MuiSnackbarContent-root': {
      minWidth: '180px',
      background: 'rgb(253, 247, 226)',
      borderBottom: '3px solid rgb(169, 111, 19)',
      '& .MuiSnackbarContent-message': {
        display: 'contents',
        '& .genie-snackbarMessage': {
          alignItems: 'center',
          whiteSpace: 'nowrap',
          color: 'black',
          '& .genie-snackbarMessage__icon': {
            marginBottom: 0,
            svg: {
              path: {
                fill: 'rgb(169, 111, 19)',
              },
            },
          },
        },
      },
    },
  },
};

function SnackbarComponent({
  open,
  onClose,
  variant,
  msg,
  ...rest
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={2000}
      anchorOrigin={{
        vertical: 'bottom', horizontal: 'right',
      }}
      transitionDuration={500}
      onClose={onClose}
      variant={variant}
      message={msg}
      action={<div />}
      ContentProps={{
        sx: VARIANT_SX[variant],
      }}
      {...rest}
    />
  );
}

SnackbarComponent.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  msg: PropTypes.string,
  variant: PropTypes.string,
};

SnackbarComponent.defaultProps = {
  open: false,
  onClose: () => {},
  variant: '',
  msg: '',
};

export default SnackbarComponent;
